import classNames from 'classnames';
import renderInlineItalic from 'lib/utils/renderInlineItalic';
import React from 'react';
import Image from 'components/shared/image/image';
import { padToTwo } from 'lib/utils/helpers';
import RichText from 'components/shared/richtext';
import Icon from 'components/shared/icon';
import useScrollIndicator from 'hooks/utils/useScrollIndicator';
import styles from './tutorial.module.scss';

const Tutorial = ({ data }) => {
  const { title, titleFont, steps, image, toggleNumbers, anchorId } = data;
  const titleClass = classNames(styles.title, titleFont !== 'Acumin Pro' && styles.octave);
  const { ref, canScrollUp, canScrollDown, scrollUp, scrollDown } = useScrollIndicator();

  const getStepLabel = (step, index) => {
    if (!toggleNumbers) return step.label || null;
    return padToTwo(index + 1);
  };

  return (
    <div id={anchorId} className={styles.wrapper}>
      <Image className={styles.imageContainer} src={image} loading="lazy" layout="fill" />
      <div className={styles.contentWrapper}>
        <div
          className={`${styles.fade} ${styles.fadeTop} ${canScrollUp ? styles.fadeVisible : ''}`}
        />
        <div
          className={`${styles.fade} ${styles.fadeBottom} ${
            canScrollDown ? styles.fadeVisible : ''
          }`}
        />
        <div ref={ref} className={styles.content}>
          <h2 className={titleClass}>{renderInlineItalic(title)}</h2>
          {React.createElement(
            toggleNumbers ? 'ol' : 'ul',
            null,
            steps.map((step, index) => {
              const label = getStepLabel(step, index);
              return (
                <li key={step.title} className={styles.step}>
                  {label && <div className={styles.stepNumber}>{label}</div>}
                  <div className={styles.stepContent}>
                    <h3 className={styles.stepTitle}>{step.title}</h3>
                    <RichText text={step.content.json} className={styles.stepText} />
                  </div>
                </li>
              );
            })
          )}
        </div>
        <button
          className={`${styles.scrollButton} ${styles.scrollUp} ${
            canScrollUp ? styles.buttonVisible : ''
          }`}
          onClick={scrollUp}
          aria-label="Scroll up"
        >
          <Icon type="arrow" width="1.1rem" heigth="0.8rem" aria-hidden="true" />
        </button>
        <button
          className={`${styles.scrollButton} ${styles.scrollDown} ${
            canScrollDown ? styles.buttonVisible : ''
          }`}
          onClick={scrollDown}
          aria-label="Scroll down"
        >
          <Icon type="arrow" width="1.1rem" heigth="0.8rem" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};

export default Tutorial;
